<template>
      <div
        class="modal trader-info mng-acc-modal"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Trader Edit</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <div class="col-md-6 form-group ">
                  <label for="tmcbrocker ">TMC Account</label>
                    <select class="form-control" v-model="traderData.tmcAccountId" >
                        <option value="">Choose A/C No</option>
                        <option v-if="tmcAccountList.length == 0" value="">Loading...</option>
                        <option
                            v-for="tmc in tmcAccountList"
                            :key="tmc.id"
                            v-bind:value="tmc.id"
                        >{{tmc.account}}</option>
                    </select>
                </div>
                <div class="col-md-6 form-group ">
                  <label for="bondpointbrocker">BondPoint Account</label>
                    <select class="form-control" v-model="traderData.ibpAccountId" >
                        <option value="">Choose A/C No</option>
                        <option v-if="bpAccountList.length == 0" value="">Loading...</option>
                        <option
                            v-for="bp in bpAccountList"
                            :key="bp.id"
                            v-bind:value="bp.id"

                        >{{bp.account}}</option>
                    </select>
                </div>
                <div class="col-md-6 form-group ">
                    <label for="tradewebbrocker">TradeWeb Account</label>
                        <select class="form-control mb-2" v-model="traderData.twdAccountId" >
                            <option value="">Choose A/C No</option>
                            <option v-if="twAccountList.length == 0" value="">Loading...</option>
                            <option
                                v-for="tw in twAccountList"
                                :key="tw.id"
                                v-bind:value="tw.id"
                            >{{tw.account}}</option>
                    </select>
                </div>
                <div class="col-md-6 form-group ">
                    <label for="tradewebbrocker">MarketAxess Account</label>
                        <select class="form-control mb-2" v-model="traderData.mktxAccountId" >
                            <option value="">Choose A/C No</option>
                            <option v-if="mktxAccountList.length == 0" value="">Loading...</option>
                            <option
                                v-for="mktx in mktxAccountList"
                                :key="mktx.id"
                                v-bind:value="mktx.id"
                            >{{mktx.account}}</option>
                    </select>
                </div>
                <div class="col-md-6 form-group">
                    <label for="tradewebbrocker">Rank</label>
                    <input type="number" class="form-control" id="Return"  v-model.number="traderData.rankId" >
                </div>
                <!--  <div class="col-md-6 form-group required">
                    <label for="tradewebbrocker">Max. Par Value/Cusip</label>
                    <input type="number" class="form-control" id="Return"  v-model.number="traderData.offerMaxParValue" >
                </div>
                 <div class="col-md-6 form-group required">
                    <label for="tradewebbrocker">Max. Capital</label>
                    <input type="number" class="form-control" id="Return"  v-model.number="traderData.offerMaxCapital" >
                </div> -->
                 <div class="col-md-6 form-group">
                    <label for="tradewebbrocker">Trader ID</label>
                    <input type="tel" onKeyDown="if(this.value.length==2 && event.keyCode!=8) return false;" class="form-control" id="Return"  v-model.number="traderData.traderId" >
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                 
                </div>
              </div>
                <div class="modal-footer">
                  <button class="btn btn-light" type="button" @click="$emit('close')">Cancel</button>
                  <button class="btn btn-success" type="button" @click="updateTrader()">SAVE</button>
                </div>
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
               <p v-if="errors.length">
                        <ul>
                        <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                        </ul>
                    </p>
               <!-- <p v-if="error">
                  <ul>
                  <li class="alert alert-danger" role="alert">Account number is required.</li>
                  </ul>
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </template>

    <script>
     import authService from "@/authService";
     import config from "@/config";

    export default {
        name: 'traderModal',
        components :{
            
        },
        props: ['traderData'],
        data() {
            return {
                tmcAccountList : [],
                bpAccountList : [],
                twAccountList : [],
                mktxAccountList : [],
                loading : false,
                errors : []
            };
        },
        methods: {   
            getBrokerAccountList(){
                this.loading = true;
                const auth = {
                headers: {'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                    config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD,MKTX",
                    auth
                )
                .then(response => {
                    this.loading = false;
                    this.bpAccountList = response.data.filter((item) => {
                        return item.ecn == 'IBP' && item.accountValue != 'SMU0000042'
                    });
                    this.tmcAccountList = response.data.filter((item) => {
                        return item.ecn == 'TMC'
                    });
                    this.twAccountList = response.data.filter((item) => {
                        return item.ecn == 'TWD'
                    });
                    this.mktxAccountList = response.data.filter((item) => {
                        return item.ecn == 'MKTX'
                    });
                })
                .catch(e => {
                    console.log(e);
                });
          },
          updateTrader(){
            let isValid = this.checkForm();
            if (isValid) {
              this.loading = true;
              var data = {};
                  data.userId = this.traderData.id;
                  data.traderId = this.traderData.traderId;
                  data.rankId = this.traderData.rankId;
                  // data.offerMaxCapital = this.traderData.offerMaxCapital;
                  // data.offerMaxParValue = this.traderData.offerMaxParValue;
                  data.traderAccountDtoList = [
                    {"accountId":this.traderData.ibpAccountId,"ecn": "IBP"},
                    {"accountId":this.traderData.tmcAccountId,"ecn": "TMC"},
                    {"accountId":this.traderData.twdAccountId,"ecn": "TWD"},
                    {"accountId":this.traderData.mktxAccountId,"ecn": "MKTX"},
                  ]
              const auth = {
                  headers: { 'org-token' : authService.getOrgToken()  }
              };
              this.$http
              .put(config.baseUrlBidSide + "/trader", data, auth)
              .then(() => {
                  this.loading = false;              
                  this.$emit('close');               
                                
              })
              .catch(() => {
                  this.loading = false;              
              });
            }
          },
          checkForm(){
            this.errors = [];
            if (!this.traderData.rankId) {
                this.errors.push("Rank is required.");
                return false;
            }
            // if (!this.traderData.ibpAccountId) {
            //     this.errors.push("BondPoint Account is required.");
            //     return false;
            // }
            // if (!this.traderData.twdAccountId) {
            //     this.errors.push("TradeWeb Account is required.");
            //     return false;
            // }
            // if (!this.traderData.offerMaxCusips) {
            //     this.errors.push("Max. # of cusip is required.");
            //     return false;
            // }
            // if (!this.traderData.offerMaxParValue) {
            //     this.errors.push("Max. Par Value/Cusip is required.");
            //     return false;
            // }
            // if (!this.traderData.offerMaxCapital) {
            //     this.errors.push("Max. Capital is required.");
            //     return false;
            // }
            // if (!this.traderData.traderId) {
            //     this.errors.push("Trader ID is required.");
            //     return false;
            // }
                return true

          }  
        },
        mounted() {
          this.getBrokerAccountList();
          
        }
    };
    </script>